module.exports = __webpack_public_path__ + "static/img/sahngyejiegou.f50c4c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7mouth/sahngyejiegou.png
// module id = +6NK
// module chunks = 1